import { DetailsBooking } from 'types';

export const showDepositPayAdyenMigrationInfo = (booking: DetailsBooking): boolean => {
  const { hasPendingScheduledPayment, requiresPaymentMethodUpdate } = booking.flags;
  const notYetMigrateToAdyenPaymentGateway = requiresPaymentMethodUpdate;

  return hasPendingScheduledPayment && notYetMigrateToAdyenPaymentGateway;
};
